import React from 'react'
import AboutHeroImg from '../assets/about.png';

const About = () => {
  return (
    <div>
      <>
  {/* Banner */}
  <section className="banner">
    <img
      id="banner-img"
      src= {AboutHeroImg}
      alt="About Speech Innovation NC"
    />
  </section>
  {/* Who We Are Section */}
  <section className="row mb-5">
    <div className="col-lg-8 mx-auto">
      <div className="text-center mb-5 text-secondary fade-up">
        <h2>
          Dedicated to empowering communication and transforming lives since
          2011
        </h2>
      </div>
      <div className="p-5 rounded-4 mb-5 fade-up">
        <h2 className="h3 mb-4 text-black">Who We Are</h2>
        <p className="fs-5 mb-0">
          Speech Innovation NC, PLLC, founded in 2011, is a clinician-owned
          bilingual speech-language pathology center serving clients of all
          ages. Our commitment to excellence and personalized care has made us a
          trusted partner for families throughout the Charlotte region.
        </p>
      </div>
    </div>
  </section>
  {/* Our Approach Section */}
  <section className="row mb-5">
    <div className="col-lg-10 mx-auto">
      <div className="fade-up">
        <h2 className="h3 mb-4 text-center">Our Personalized Approach</h2>
        <p className="fs-5 mb-4 text-center text-muted">
          Every individual is unique, and so is their path to better
          communication
        </p>
        <div className="bg-opacity-5 p-5 rounded-4">
          <p className="fs-5 mb-4">
            Speech Innovation NC provides personalized, evidence-based treatment
            services that empower individuals to reach their full potential and
            promote independence in their community.
          </p>
          <p className="mb-0 text-black">
            We believe in creating a warm, supportive environment where clients
            feel comfortable and confident as they work toward their
            communication goals. Our bilingual services ensure that we can serve
            our diverse community with cultural sensitivity and understanding.
          </p>
        </div>
      </div>
    </div>
  </section>
  {/* Services Overview */}
  <section className="row mb-5">
    <div className="col-12">
      <div className="text-center mb-5 fade-up">
        <h2 className="h3 mb-3">Areas of Expertise</h2>
        <p className="lead text-muted">
          Comprehensive speech-language pathology services
        </p>
      </div>
      <div className="row g-4">
        <div className="col-md-6 col-lg-4 fade-up">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body p-4">
              <h5 className="card-title">Language &amp; Communication</h5>
              <p className="card-text text-muted">
                Language development, sociopragmatic skills, and augmentative
                &amp; alternative communication
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 fade-up">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body p-4">
              <h5 className="card-title">Speech Disorders</h5>
              <p className="card-text text-muted">
                Apraxia, articulation, fluency disorders, and voice therapy
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 fade-up">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body p-4">
              <h5 className="card-title">Specialized Services</h5>
              <p className="card-text text-muted">
                Orofacial myofunctional therapy, feeding &amp; swallowing, and
                literacy support
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* Key Differentiators */}
  <section className="row mb-5">
    <div className="col-lg-12 mx-auto">
      <div className="p-5 rounded-4 fade-up text-center">
        <h2 className="h3 mb-4 text-center">What Sets Us Apart</h2>
        <div className="row g-4">
          <div className="col-md-3">
            <div className="d-flex">
              <div
                className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                style={{ width: 40, height: 40 }}
              >
                <span className="text-success fw-bold">✓</span>
              </div>
              <div>
                <h5 className="fw-bold mb-1 text-center">Bilingual Services</h5>
                <p className="text-muted mb-0">
                  Culturally sensitive care in multiple languages
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="d-flex">
              <div
                className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                style={{ width: 40, height: 40 }}
              >
                <span className="text-success fw-bold">✓</span>
              </div>
              <div>
                <h5 className="fw-bold mb-1 text-center">Evidence-Based Practice</h5>
                <p className="text-muted mb-0">
                  Latest research-backed treatment methods
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="d-flex">
              <div
                className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                style={{ width: 40, height: 40 }}
              >
                <span className="text-success fw-bold">✓</span>
              </div>
              <div>
                <h5 className="fw-bold mb-1 text-center">All Ages Welcome</h5>
                <p className="text-muted mb-0">
                  From early intervention to adult rehabilitation
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="d-flex">
              <div
                className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                style={{ width: 40, height: 40 }}
              >
                <span className="text-success fw-bold">✓</span>
              </div>
              <div>
                <h5 className="fw-bold mb-1 text-center">Clinician-Owned</h5>
                <p className="text-muted mb-0">
                  Direct access to experienced professionals
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

    </div>
  )
}

export default About
